import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5180245e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["element-loading-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "login-transit-wrap",
    "element-loading-text": _ctx.$t('login.loading')
  }, [
    _withDirectives(_createVNode(_component_LoginForm, { "with-team": _ctx.withTeam }, null, 8, ["with-team"]), [
      [_vShow, false]
    ])
  ], 8, _hoisted_1)), [
    [_directive_loading, true]
  ])
}